module.exports = __webpack_public_path__ + "img/metrobank.f37f95c7.png";